module.exports = __webpack_public_path__ + "v4assets/perf-monitor-services-dark.bc45058dc6d6bd8af50de0d8ec6961af.png";